import { React } from 'Imports';
import { Button } from 'MaterialUIComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/pro-regular-svg-icons';
import { isEncompass } from '$Utilities/integrationPlatform';

interface IExportButtonProps {
    onClick: () => void;
    disabled?: boolean;
    title?: string;
}

const styles = require('$Components/FilterComponents/Buttons/ExportButton.scss') as {
    exportButton: string;
    exportButtonEncompass: string;
    exportButtonGeotab: string;
    fileDownload: string;
    disabled: string;
    downloadBtn: string;
    downloadBtnEncompass: string;
};

export const ExportButton = (props: IExportButtonProps) => {
    const { onClick, disabled = false, title = 'Export' } = props;

    return (
        <Button
            className={`${styles.exportButton} ${isEncompass ? styles.exportButtonEncompass : styles.exportButtonGeotab}`}
            onClick={onClick}
            disabled={disabled}
            disableRipple
            title={title}
        >
            <FontAwesomeIcon icon={faFileExport} size={'lg'} />
            {title}
        </Button>
    );
};
